import React from "react";
import { X, Check, Image as ImageIcon, Video, Clock } from "lucide-react";
import { useTheme } from "@context/ThemeContext";
import { getPublicVideoLabel } from "../../../utils/projectRuntime";

const HistoryPanel = ({ historyList, type, onRestore, onClose, exiting }) => {
  const { getTheme } = useTheme();
  const theme = getTheme();
  const filteredList = (historyList || []).filter((item) => item.type === type);

  return (
    <div
      className={`rounded-xl shadow-2xl z-50 overflow-hidden flex flex-col max-h-80 w-64 ${exiting ? "animate-out fade-out zoom-out-95 duration-150" : "animate-in fade-in zoom-in-95"}`}
      style={{ backgroundColor: 'var(--color-bg-secondary)', border: 'var(--color-border-primary)' }}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-2 shrink-0" style={{ backgroundColor: 'var(--color-bg-tertiary)', borderBottom: 'var(--color-border-secondary)' }}>
        <div className="flex items-center gap-2 text-xs font-bold" style={{ color: 'var(--color-text-primary)' }}>
          <Clock size={12} style={{ color: theme.colors.accentPrimary }} />
          {type === "image" ? "历史图片" : "历史视频"} ({filteredList.length})
        </div>
        <button onClick={onClose} className="p-1 rounded transition-all duration-200 hover:bg-[var(--color-bg-tertiary)]" style={{ color: 'var(--color-text-muted)' }}>
          <X size={12} />
        </button>
      </div>

      {/* List */}
      <div className="overflow-y-auto custom-scrollbar p-2 space-y-2 flex-1">
        {filteredList.length === 0 ? (
          <div className="text-center py-6 text-xs" style={{ color: 'var(--color-text-muted)' }}>暂无历史记录</div>
        ) : (
          [...filteredList].reverse().map((item, i) => (
            <div
              key={i}
              className="flex gap-2 p-2 rounded-lg transition-all duration-200 border border-transparent"
              style={{ backgroundColor: 'var(--color-bg-primary)' }}
              onMouseEnter={(e) => { e.currentTarget.style.borderColor = 'var(--color-border-primary)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'transparent'; }}
            >
              {/* Thumbnail */}
              <div
                className="w-14 h-14 rounded overflow-hidden shrink-0 relative cursor-pointer"
                style={{ backgroundColor: 'black' }}
                onClick={() => window.open(item.url, '_blank')}
                title="点击预览"
              >
                {item.type === 'video' ? (
                    <video src={item.url} preload="none" className="w-full h-full object-cover" muted onMouseOver={e=>e.target.play()} onMouseOut={e=>e.target.pause()}/>
                ) : (
                    <img src={item.url} className="w-full h-full object-cover" loading="lazy"/>
                )}
              </div>

              {/* Info & Action */}
              <div className="flex-1 min-w-0 flex flex-col justify-between py-0.5">
                  <div>
                      <div className="flex justify-between items-center text-2xs" style={{ color: 'var(--color-text-muted)' }}>
                          <span>{new Date(item.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                          <span className="px-1 rounded text-2xs" style={{ backgroundColor: 'var(--color-bg-tertiary)' }}>{getPublicVideoLabel(item.model, "AI")}</span>
                      </div>
                      <div className="text-2xs truncate leading-tight mt-0.5" style={{ color: 'var(--color-text-secondary)' }} title={item.prompt}>
                        {item.prompt || "无提示词"}
                      </div>
                  </div>
                  <button
                    onClick={() => onRestore(item)}
                    className="self-end text-2xs font-medium flex items-center gap-1 px-2 py-0.5 rounded transition-all duration-200"
                    style={{
                      backgroundColor: 'var(--color-accent-light)',
                      color: theme.colors.accentSecondary,
                      border: `1px solid ${theme.colors.accentPrimary}`
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = theme.colors.accentPrimary; e.currentTarget.style.color = 'white'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'var(--color-accent-light)'; e.currentTarget.style.color = theme.colors.accentSecondary; }}
                  >
                      <Check size={8} /> 替换
                  </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default HistoryPanel;
